import styled from 'styled-components';
import React from 'react';

/*
 * Types
 */
export type SpinnerProps = {
    size?: number;
};

/*
 * Style
 */
const SpinnerIcon = styled.svg<Pick<SpinnerProps, 'size'>>`
    width: ${({ size }) => size ?? 50}px;
    height: ${({ size }) => size ?? 50}px;

    @keyframes spin {
        100% {
            transform: rotate(360deg);
        }
    }

    animation: spin 0.7s linear infinite;

    .spinner-icon__circle {
        fill: #698fb6;
        opacity: 0.5;
    }

    .spinner-icon__corner {
        fill: #002e90;
        opacity: 0.6;
    }
`;

/*
 * Component
 */
const Spinner: React.FC<SpinnerProps> = (props: SpinnerProps) => (
    <SpinnerIcon
        className="overlay__loading_icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 50 50"
        size={props.size}
    >
        <path
            className="spinner-icon__circle"
            d="M25 0C11.2 0 0 11.2 0 25s11.2 25 25 25 25-11.2 25-25S38.8 0 25 0zm0 40c-8.3 0-15-6.7-15-15s6.7-15 15-15 15 6.7 15 15-6.7 15-15 15z"
        />
        <path className="spinner-icon__corner" d="M0 25h10c0-8.3 6.7-15 15-15V0C11.2 0 0 11.2 0 25z" />
    </SpinnerIcon>
);

export default Spinner;
